import React, { useContext, useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";

import { baseServiceUrl, urls } from "../../environment";
import { useNavigate } from "react-router-dom";

import { Radio } from "@mui/material";

import useUserStore from "../../stores/useUserStores";
import useDomainStore from "../../stores/useDomainStore";

const CreateQuestion = () => {
  const { token, setLoading } = useUserStore();
  const domainContext = useDomainStore();
  const [complexity, setComplexity] = useState<any>(undefined);
  const [choices, setchoices] = useState(Array(2).fill(""));
  const [correct, setcorrect] = useState(-1);
  const [Subjectlist, setSubjectList] = useState<any[]>([]);
  const [question, setquestion] = useState<any>({});
  const alphabet = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
  ];
  function addnewoption() {
    const newArray = [...choices, ""];
    setchoices(newArray);
  }

  useEffect(() => {
    if (domainContext.complexity) {
      setComplexity(domainContext.complexity[0]);
    }
  }, [domainContext]);

  const toastId = React.useRef<any>(null);
  const errornotify = (msg: any) => toast.error(msg);
  const sendingnotify = (msg: any) => (toastId.current = toast.loading(msg));
  const dismiss = () => toast.dismiss(toastId.current);
  const successnotify = (msg: any) => toast.success(msg);
  const navigate = useNavigate();

  async function finalsubmitquestion() {
    if (!question.subject) {
      errornotify("Subject not choosen");
      return;
    }
    if (question.txt_question === "") {
      errornotify("Type the question");
      return;
    }
    for (let i = 0; i < choices.length; i++) {
      if (choices[i] === "") {
        errornotify("Options not provided properly");
        return;
      }
    }
    if (correct === -1) {
      errornotify("Mark the correct answer");
      return;
    }
    if (!!question?.marks && +question.marks <= 0) {
      errornotify("Mark not define");
      return;
    }
    let payload: any = {
      question: question.txt_question,
      marks: +question.marks,
      negetive_mark: !!question?.negativeMarks ? +question.negativeMarks : null,
      negetive_flag: !!question?.negativeMarks ? 1 : 0,
      question_type: question?.subject,
      correct_answer: choices[correct],
      answers: choices.map((item, index) => ({
        options_value: `(${alphabet[index]})`,
        anwser_field: item,
        correct_flag: index == correct ? true : false,
      })),
    };
    setLoading(true);
    (async () => {
      try {
        const response = await axios.post(
          baseServiceUrl + urls.createQuestionUrl,
          payload,
          {
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        );
        setLoading(false);
        if (response.status == 200) {
          successnotify("Question successfully addded.");
          navigate("/admin-dashboard/create-list");
        }
      } catch (err: any) {
        setLoading(false);
        errornotify(
          err?.response?.data?.message || "Error encounter. Please try again."
        );
      }
    })();
  }

  //new
  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const response = await axios.get(baseServiceUrl + urls.getSubjectUrl, {
          headers: {
            Authorization: "Bearer " + token,
          },
        });
        setLoading(false);
        if (response.data) {
          setSubjectList(response.data);
        }
      } catch (err: any) {
        setLoading(false);
        errornotify(
          err?.response?.data?.message || "Error encounter. Please try again."
        );
      }
    })();
  }, []);

  return (
    <>
      {/* <Toaster position="bottom-left" reverseOrder={false} /> */}
      <section
        id="create-question"
        className={`min-h-screen flex items-center py-4 justify-center`}
      >
        <div className="container w-full md:w-[70%]  lg:w-[60%] mx-auto ">
          <div className="bg-white rounded shadow-xl drop-shadow-md p-4 px-4 md:p-8 flex flex-col  w-full">
            <p className="md:text-xl  text-lg font-semibold">
              Add New Question
            </p>
            <div className="flex flex-col mt-8 ml-3 md:text-base text-sm">
              <label htmlFor="subject" className="text-sm">
                Subject<span className="text-red-700">*</span>
              </label>
              <select
                id="subject"
                name="subject"
                className="mt-1 h-10 border rounded px-4 bg-gray-50"
                onChange={(e) => {
                  setquestion({ ...question, subject: e.target.value });
                }}
              >
                <option className="text-gray-400">
                  choose subject from the list
                </option>
                {Subjectlist.map((item, key) => (
                  <option key={key} value={item.domain_key}>
                    {item.domain_value}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex flex-col mt-4 ml-3">
              <label htmlFor="message" className="text-sm">
                Question<span className="text-red-700">*</span>
              </label>
              <textarea
                id="message"
                rows={4}
                value={question.txt_question}
                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-100 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                onChange={(e) => {
                  setquestion({ ...question, txt_question: e.target.value });
                }}
              ></textarea>
            </div>

            <div className="flex flex-col mt-4 ml-3">
              <label htmlFor="message" className="text-sm">
                Options<span className="text-red-700">*</span>
              </label>
              {choices.map((item, key) => (
                <div
                  key={key}
                  className="flex items-center my-1 ps-4 border border-gray-200 rounded"
                >
                  <input
                    id="bordered-radio-1"
                    type="radio"
                    name="bordered-radio"
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500"
                    onClick={() => setcorrect(key)}
                  />
                  <input
                    type="text"
                    className="w-full py-4 ms-2 text-sm font-medium text-gray-900 outline-none"
                    placeholder="Enter Choice"
                    onChange={(e) => {
                      let temp = choices;
                      temp[key] = e.target.value;
                      setchoices(temp);
                    }}
                  />
                  {choices.length > 2 ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="cursor-pointer w-5 h-5 mr-4 hover:fill-red-400"
                      onClick={() => {
                        let temp = [...choices];
                        temp.splice(key, 1);
                        setchoices(temp);
                      }}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                      />
                    </svg>
                  ) : (
                    <></>
                  )}
                </div>
              ))}
              <span
                className=" flex items-center cursor-pointer bg-blue-500 m-2 p-[6px] px-3 rounded-3xl text-sm font-medium w-fit"
                onClick={addnewoption}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-4 h-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 4.5v15m7.5-7.5h-15"
                  />
                </svg>
                Add Choice
              </span>
            </div>
            <div className="flex flex-col mt-4 ml-3">
              <label htmlFor="subject" className="text-sm">
                Complexity<span className="text-red-700">*</span>
              </label>
              <div className="grid grid-cols-12 w-full mt-2  gap-x-5 ">
                {domainContext.complexity.map((self: any, index: number) => (
                  <div
                    className="col-span-4 cursor-pointer border flex items-center justify-center border-gray-200 rounded-md py-3 relative"
                    key={index}
                  >
                    <Radio
                      checked={
                        complexity && self.domain_key === complexity.domain_key
                      }
                      sx={{ position: "absolute", top: "1%", right: "2%" }}
                    />
                    {self.domain_value}
                  </div>
                ))}
              </div>
            </div>
            <div className="flex flex-col mt-4 ml-3">
              <label htmlFor="subject" className="text-sm">
                Marks<span className="text-red-700">*</span>
              </label>
              <input
                type="number"
                value={question?.marks}
                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-100 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter Marks"
                onChange={(e) =>
                  setquestion({ ...question, marks: e.target.value })
                }
              />
            </div>
            <div className="flex flex-col mt-4 ml-3">
              <label htmlFor="subject" className="text-sm">
                Negetive Mark
              </label>
              <input
                type="number"
                value={question?.negativeMarks}
                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-100 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter Negetive Mark"
                onChange={(e) =>
                  setquestion({ ...question, negativeMarks: e.target.value })
                }
              />
            </div>
            <div className="flex items-center justify-center">
              <button
                type="button"
                className="mt-10 w-[30%] bg-gray-800 hover:bg-opacity-90 text-white font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                onClick={finalsubmitquestion}
              >
                Submit Question
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CreateQuestion;
